// UserProfileList.js
import React from 'react';
import { Row, Col } from 'antd';
import UserProfileCard from './UserProfileCard';

const UserProfileList = ({ profiles }) => {
  if (!Array.isArray(profiles) || profiles.length === 0) {
    return null;
  }

  return (
    <Row gutter={16}>
      {profiles.map((profile, idx) => (
        <Col key={profile?.ID || profile?.Id || idx} xs={24} sm={24} md={24} lg={12} xl={8} className="mb-3">
          <UserProfileCard profile={profile} />
        </Col>
      ))}
    </Row>
  );
};

export default UserProfileList;
